import { render, staticRenderFns } from "./standList.vue?vue&type=template&id=30210d14"
import script from "./standList.vue?vue&type=script&lang=js"
export * from "./standList.vue?vue&type=script&lang=js"
import style0 from "./standList.vue?vue&type=style&index=0&id=30210d14&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports